import KorekSignup from "../Pages/SignUp/korek/korek-signup";
import KsaSignup from "../Pages/SignUp/KsaSignup/KsaSignup";
import ZainSignup from "../Pages/SignUp/zain-iraq/ZainSignup";
import DzoSignin2 from "../Pages/SignIn/DzoSignin/DzoSignin2";
import SignIn from "../Pages/SignIn/SignIn";

import EtuSignin from "../Pages/SignIn/EtuSignin/EtuSignin";
import KorekSignin from "../Pages/SignIn/KorekSignin/KorekSignin";
import KsaSignin from "../Pages/SignIn/KsaSignin/KsaSignin";
import AciqSignin from "../Pages/SignIn/AciqSignin/aciqSignin";

import ZainSignin from "../Pages/SignIn/ZainSignin/ZainSignin";
// import EtisalatSignUp from "../Pages/SignUp/EtisalatSignUp";
import SignUpNewdzo from "../Pages/SignUp/SignUpNewdzo";
import SuccessKorek from "../Pages/SignUp/korek/korek-success";
import ZainThankyouPage from "../Pages/SignUp/zain-iraq/ThankyouPage";
import Success from "../Pages/Success/Success";
import KsaSuccess from "../Pages/SignUp/KsaSignup/KsaSuccess";
import EtisalatSignUp from "../Pages/SignUp/EtisalatSignUp";
import AciqSignup from "../Pages/SignUp/aciqSignup/aciqSignup";
import LibyaSignup from "../Pages/SignUp/libya/libyaSignup";
import MtnzaSignup from "../Pages/SignUp/southAfrica/MtnzaSignup";
import KsaLebaraSignup from "../Pages/SignUp/ksa/KsaLebaraSignup";
// import IraqSignup from "../pages/SignUp/IraqSignUp";
const hostNamesInfo = [
  {
    hostName: "dzo.gamerclub.live",
    theme: "iraq",
  },
  {
    hostName: "localhost",
    theme: "iraq",
    // theme: "iraq",
  },
];
export const getHostComponentByRoute = (route) => {
  const hostname = document.location.host;
  if (route === "signup") {
    switch (hostname) {
      // Algeria
      case "dzo.gamerclub.live": // terminated, old design
        return <SignUpNewdzo />;
      case "etuae.gamerclub.live": // will be refactored -- vas1, old design
        return <EtisalatSignUp />;
      case "ziq.gamerclub.live": //worlinks new design
        return <ZainSignup />;
      case "korek.gamerclub.live": //worlinks new design
        return <KorekSignup />;
      case "ksa.gamerclub.live": //worlinks new design
        return <KsaSignup />;
        case "aciq.gamerclub.live": //worlinks new design
        return <AciqSignup />;
         case "libyad.gamerclub.live": 
        return <LibyaSignup/>;
        case "gamerclub.ly": 
        return <LibyaSignup/>;
        case "mtnza.gamerclub.live": 
        return <MtnzaSignup/>;
        case "lebara.gamerclub.live": 
        return <KsaLebaraSignup/>;
      default:
        return <MtnzaSignup />;
    }
  }
};
export const getSignup2ComponentByHost = () => {
  const hostname = document.location.hostname;
  if (hostname.includes("aciq")) {
    return <AciqSignup />;
  }
  return <SignUpNewdzo />;
};

export const getHostSuccessComponentByRoute = (route) => {
  const hostname = document.location.host;
  if (route === "success") {
    switch (hostname) {
      case "ziq.gamerclub.live": //worlinks new design
        return <ZainThankyouPage />;
      case "korek.gamerclub.live": //worlinks new design
        return <SuccessKorek />;
      case "ksa.gamerclub.live": //worlinks new design
        return <KsaSuccess />;
        
      default:
        return <Success />;
    }
  }
};
export const getHostSigninComponentByRoute = (route) => {
  const hostname = document.location.host;
  if (route === "signIn") {
    switch (hostname) {
      // Algeria
      case "dzo.gamerclub.live": // terminated, old design
        return <DzoSignin2 />;
      case "etuae.gamerclub.live": // will be refactored -- vas1, old design
        return <EtuSignin />;
      case "ziq.gamerclub.live": //worlinks new design
        return <ZainSignin />;
      case "korek.gamerclub.live": //worlinks new design
        return <KorekSignin />;
      case "ksa.gamerclub.live": //worlinks new design
        return <KsaSignin />;
         case "aciq.gamerclub.live": //worlinks new design
        return <AciqSignin />;
         case "libyad.gamerclub.live": 
        return <LibyaSignup/>;
        case "gamerclub.ly": 
        return <LibyaSignup/>;
        case "mtnza.gamerclub.live": 
        return <MtnzaSignup/>;
      default:
        return <SignIn />;
    }
  }
};
export const getThemeByHostName = (hostName) => {
  const hostNameInfo = hostNamesInfo.find((i) => i.hostName === hostName);
  if (hostNameInfo) {
    //console.log('theme', hostNameInfo.theme, hostNameInfo.hostName)
    return hostNameInfo.theme;
  }
  return false;
};
